import { render, staticRenderFns } from "./DynamicPageRenderer.vue?vue&type=template&id=7fcf4c9e&"
import script from "./DynamicPageRenderer.vue?vue&type=script&lang=js&"
export * from "./DynamicPageRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports